// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Checkbox_wrapper__CxstR","input":"Checkbox_input__Vg7_5","label":"Checkbox_label__5tcyh","errorLabel":"Checkbox_errorLabel__JCN__","disabled":"Checkbox_disabled__8h_n0"};